import React, {useContext} from 'react';
import {Apis} from './Apis';

// ApisContext doesn't have a default value, but we don't reflect that in its type, for simplicity.
const defaultApiValue: Apis = null as unknown as Apis;

export const ApisContext = React.createContext<Apis>(defaultApiValue);

export const useApis = () => useContext(ApisContext);
